/**
 * The tab bar shared by the entity-config pages. Generic over each page's own Tab
 * union so a page still can't render a tab it doesn't handle.
 */
export default function TabBar<T extends string>({
    tabs,
    activeTab,
    onChange,
    scrollable = false
}: {
    tabs: readonly T[]
    activeTab: T
    onChange: (tab: T) => void
    /** For wide tab sets (profile config has eight) — scroll rather than wrap. */
    scrollable?: boolean
}) {
    return (
        <div
            className={`flex border-b border-gray-200 bg-white px-6 ${scrollable ? 'overflow-x-auto' : ''}`}
        >
            {tabs.map((tab) => (
                <button
                    key={tab}
                    type="button"
                    onClick={() => onChange(tab)}
                    className={`whitespace-nowrap border-b-2 px-4 py-2.5 text-sm font-medium transition-colors ${
                        activeTab === tab
                            ? 'border-arwen-600 text-arwen-700'
                            : 'border-transparent text-gray-800 hover:text-gray-900'
                    }`}
                >
                    {tab}
                </button>
            ))}
        </div>
    )
}
